function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { XS_M } from "constants/sizes";
import LogosTitleComponent from "segments/desktop/logos/components/logos-title/logos-title-component";
import Logos from "segments/desktop/core-components/logos/logos";
import { componentStyles } from "./slim-logos-component.scss";
const SlimLogosComponent = (props)=>{
    const { title, titleSize, textAlign, logos } = props;
    return /*#__PURE__*/ _jsxs("div", {
        className: `jsx-${componentStyles.__hash}` + " " + "slim-logos-component",
        children: [
            /*#__PURE__*/ _jsx(LogosTitleComponent, {
                title: title,
                titleSize: titleSize,
                textAlign: textAlign,
                padding: 0
            }),
            /*#__PURE__*/ _jsx(Logos, _object_spread_props(_object_spread({}, logos), {
                slim: true
            })),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
SlimLogosComponent.defaultProps = _object_spread_props(_object_spread({}, LogosTitleComponent.defaultProps), {
    logos: Logos.defaultProps,
    titleSize: XS_M,
    textAlign: "left",
    paddingTop: "68px",
    paddingBottom: "68px",
    mobilePaddingTop: "24px",
    mobilePaddingBottom: "24px"
});
export default SlimLogosComponent;
